<template>
    <div class="page-wrapper report-page-wrapper">
        <div class="header-wrapper">
            <van-dropdown-menu>
                <van-dropdown-item @change="handleRecentlyMonthChange" v-model="recentlyMonth" :options="monthSelectList" />
            </van-dropdown-menu>
            <van-button @click="handleCalendarDailogShow('start')" type="default">{{ startDate ? startDate : '选择日期范围'}}</van-button>
            <van-button @click="handleCalendarDailogShow('end')" type="default">{{ endDate ? endDate : '选择日期范围'}}</van-button>
        </div>

        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div v-if="reportList.length > 0" class="report-item-list-wrapper">
                <report-item v-for="(item, index) in reportList" :key="index" :item="item"></report-item>
            </div>
            <van-empty v-else description="暂无报告" />
        </van-pull-refresh>

        <van-calendar 
            position="top" 
            :min-date="minDate"
            :max-date="maxDate"
            :title="calendarTitle"
            v-model="calendarShow" 
            color="#0098DD"
            @confirm="onCalendarSelectConfirm" 
            :poppable="true"/>
    </div>
</template>

<script>
import {dateFormat} from '@/utils/date';
import ReportItem from '../../components/report-item/index'
export default {
    components:{
        ReportItem,
    },
    created(){

    },
    mounted(){
        this.getReports()
    },
    computed:{
        calendarTitle(){
            return this.calendarSelectType === 'start' ? '报告最早日期' : '报告最晚日期'
        },
    },
    data() {
        return {
            startDate: '',
            endDate: '',
            minDate: new Date(new Date().getFullYear() - 10, 0, 31),  
            maxDate: new Date(new Date().getFullYear() + 10, 0, 31), 
            calendarSelectType: '',
            recentlyMonth: 0,
            calendarShow: false,
            isLoading: false,
            reportList: [],
            monthSelectList: [
                { text: '所有时间', value: 0 },
                { text: '近一月', value: 1 },
                { text: '近三月', value: 3 },
            ]
        };
    },
    methods:{
        onCalendarSelectConfirm(date){
            const selectedDate = dateFormat("yyyy-MM-dd",new Date(date))
            this.calendarSelectType === 'start' ? this.startDate = selectedDate : this.endDate = selectedDate
            this.calendarShow = false
            this.getReports()
        },
        handleCalendarDailogShow(type){
            this.calendarSelectType = type
            this.calendarShow = true
        },
        handleRecentlyMonthChange(value){
            this.startDate = ''
            this.endDate = ''
            this.getReports()
        },
        onRefresh(){
            this.getReports()
        },
        getReports(){
            const _this = this
            _this.isLoading = true
            _this.$get('/lims6Report/getReport/' + '1' + '/' + '10' ,{
                startTime: _this.startDate,
                endTime: _this.endDate,
                lessMonth: _this.recentlyMonth === 0 ? '' : 'M' + _this.recentlyMonth
            }).then(res => {
                if(res.data.data){
                    _this.reportList = res.data.data.records
                }
               _this.isLoading = false
            }).finally(()=>{
 
            })
        },
    }
}
</script>

<style lang="scss">
.header-wrapper{
    display: flex;
    flex-direction: row;

    .van-dropdown-menu{
        flex: 1;
    }

    .van-dropdown-menu__bar::before{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        border-bottom: 1px solid #000 ;
    }
    
    .van-dropdown-menu__bar{
        box-shadow: none;
    }

    .van-button{
        flex: 1;
        height: 48px;
        border-left: none;
        border-right: none;
    }

}

.van-pull-refresh{
    height: calc(100vh - 48px);
}
</style>